function Switch(props) {
  return (
    <>
      <input
        id={props.id}
        type='checkbox'
        tabIndex={props.tabIndex}
        role='switch'
        aria-checked={props.checked}
        onChange={(event) => props.onChange(event)}
        checked={props.checked}
        disabled={props.disabled}
      />
      <span className='slider round' />
    </>
  );
}

export default Switch;
